declare namespace $ {

	type $mol_list__rows_bog_vmap_app_palette_1 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_palette['class_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_list__rows_bog_vmap_app_palette_2 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_palette['port_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_form_field__name_bog_vmap_app_palette_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__bids_bog_vmap_app_palette_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form_field['bids'] >
	>
	type $mol_form_field__control_bog_vmap_app_palette_5 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_palette['Class_list'] >
		,
		ReturnType< $mol_form_field['control'] >
	>
	type $mol_form_field__name_bog_vmap_app_palette_6 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_palette['selected_title'] >
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__bids_bog_vmap_app_palette_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form_field['bids'] >
	>
	type $mol_form_field__control_bog_vmap_app_palette_8 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_palette['Port_list'] >
		,
		ReturnType< $mol_form_field['control'] >
	>
	type $bog_vmap_app_palette_item__title_bog_vmap_app_palette_9 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_palette['class_title'] >
		,
		ReturnType< $bog_vmap_app_palette_item['title'] >
	>
	type $bog_vmap_app_palette_item__click_bog_vmap_app_palette_10 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_palette['class_click'] >
		,
		ReturnType< $bog_vmap_app_palette_item['click'] >
	>
	type $bog_vmap_app_palette_item__current_bog_vmap_app_palette_11 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_palette['class_current'] >
		,
		ReturnType< $bog_vmap_app_palette_item['current'] >
	>
	type $bog_vmap_app_palette_item__drag_start_bog_vmap_app_palette_12 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_palette['class_drag'] >
		,
		ReturnType< $bog_vmap_app_palette_item['drag_start'] >
	>
	type $bog_vmap_app_palette_port__sign_bog_vmap_app_palette_13 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_palette['port_sign'] >
		,
		ReturnType< $bog_vmap_app_palette_port['sign'] >
	>
	type $bog_vmap_app_palette_port__body_bog_vmap_app_palette_14 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_palette['port_body'] >
		,
		ReturnType< $bog_vmap_app_palette_port['body'] >
	>
	type $bog_vmap_app_palette_port__owner_bog_vmap_app_palette_15 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_palette['port_owner'] >
		,
		ReturnType< $bog_vmap_app_palette_port['owner'] >
	>
	type $bog_vmap_app_palette_port__needle_bog_vmap_app_palette_16 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_palette['query'] >
		,
		ReturnType< $bog_vmap_app_palette_port['needle'] >
	>
	type $bog_vmap_lib__pack_bog_vmap_app_palette_17 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_palette['pack_link'] >
		,
		ReturnType< $bog_vmap_lib['pack'] >
	>
	type $bog_vmap_lib__classes_bog_vmap_app_palette_18 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_palette['land_classes'] >
		,
		ReturnType< $bog_vmap_lib['classes'] >
	>
	export class $bog_vmap_app_palette extends $mol_list {
		body( ): readonly($mol_view)[]
		total( ): string
		class_rows( ): readonly(any)[]
		Class_list( ): $mol_list
		selected_title( ): string
		chain_title( ): string
		port_rows( ): readonly(any)[]
		Port_list( ): $mol_list
		class_title( id: any): string
		class_click( id: any, next?: any ): any
		class_current( id: any): boolean
		class_drag( id: any, next?: any ): any
		port_sign( id: any): string
		port_body( id: any): string
		port_owner( id: any): string
		pack_link( ): string
		query( next?: string ): string
		selected( next?: string ): string
		compact( ): boolean
		dragged( next?: string ): string
		drag_x( next?: number ): number
		drag_y( next?: number ): number
		land_classes( ): readonly($mol_tree2)[]
		rows( ): ReturnType< $bog_vmap_app_palette['body'] >
		Classes( ): $mol_form_field
		Ports( ): $mol_form_field
		Class_row( id: any): $bog_vmap_app_palette_item
		Port_row( id: any): $bog_vmap_app_palette_port
		Lib( ): $bog_vmap_lib
	}
	
}

//# sourceMappingURL=palette.view.tree.d.ts.map